import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import Item from '../../../shared/TechSkills/Item';
import AddItem from '../../../shared/TechSkills/AddItem';
import DragNDropList from '../../../shared/DragNDropList';
import config from '../../../config';

const DevelopmentMethodologiesTab = ({ data, onChange }) => {

  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('developmentMethodologies' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'developmentMethodologies',
          value: {
            enable: false,
            heading: 'Development Methodologies',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'developmentMethodologies' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('developmentMethodologies.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.developmentMethodologies.enable}
              onChange={v => onChange('data.developmentMethodologies.enable', v)}
            />
          </div>
        </div>

        <hr className="my-6" />

        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="developmentMethodologies"
        >
          {data.developmentMethodologies.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.developmentMethodologies.items.length - 1}
              type='developmentMethodologies'
              idTab={config.TECH_SKILLS_TABS.developmentMethodologies}
            />
          ))}          
        </DragNDropList>


        <AddItem heading={data.developmentMethodologies.heading} dispatch={dispatch} type='developmentMethodologies' idTab={config.TECH_SKILLS_TABS.developmentMethodologies} />
      </>
    )
  );
};

export default DevelopmentMethodologiesTab;
